import { organizationUserQueryKeys } from "@/api/query-keys/organizations"
import { OrganizationUserForm } from "@/components/forms/organizationUser/OrganizationUserForm"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useRouter } from "@tanstack/react-router"
import { FormStyle } from "toptaal-shared"

export const Route = createFileRoute(
  "/organisatie-profiel/medewerkers/aanmaken",
)({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("create", "contacts"),
})

function RouteComponent() {
  const router = useRouter()
  const queryClient = useQueryClient()

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: organizationUserQueryKeys.all,
    })

    router.navigate({
      to: "/organisatie-profiel/medewerkers",
      replace: true,
    })
  }

  return (
    <FormStyle className="mx-auto">
      <h2 className="text-center text-xl mb-8">Nieuwe medewerker</h2>

      <OrganizationUserForm handleSuccess={handleSuccess} type="create" />
    </FormStyle>
  )
}
